<template>
  <div>
    <HeadNav :title="headNavImg.title"
      :titleEn="headNavImg.profiles"
      :src="headNavImg.picture"></HeadNav>
    <div class="content">
      <el-row>
        <el-col
          :span="6"
          style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);"
        >
          <ContentNav :List="list" title="竞争力分析" titleEn="LCompetitive Analysis" @increase='init'></ContentNav>
        </el-col>
         <el-col :span="18" style="padding:0 50px;">
          <h3>{{headTitle}}</h3>
          <el-divider></el-divider>
          <div v-html='contentHtmlPC' v-loading='loading'></div>
          <!-- <div>
              <p>聚跃检测竞争力分析业务，是以IC设计辅助软件为核心优势的集成电路技术分析、知识产权侵权分析和芯片设计的服务公司</p>
              <p>公司利用自主研发的芯片EDA工具ChipVision，结合先进的图像自动识别算法，提高了芯片解析的自动化程度。</p>
              <el-row :gutter="100">
                  <el-col :span='12'>
                      <img :src="require('../assets/组8.png')" alt="" height="200px" width="100%">
                  </el-col>
                  <el-col :span='12'>
                      <img :src="require('../assets/组7.png')" alt="" height="200px" width="100%">
                  </el-col>
              </el-row>
              <p>竞争力分析业务，致力于为客户提供优质的芯片解析服务，帮助IC设计企业掌握世界最先进的技术，促进国内集成电路行业的发展。</p>
              <p>公司利用自主研发的芯片EDA工具ChipVision，结合先进的图像自动识别算法，提高了芯片解析的自动化程度。</p>
              <el-row :gutter="100">
                  <el-col :span='12'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>芯片去层</span>
                          <p>提供芯片化学处理，物理刻蚀，保证芯 片最好的平整度及洁净</p>
                      </div>
                  </el-col>
                  <el-col :span='12'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>芯片拍照</span>
                          <p>提供光学及电子扫描显微图像，保证照片高 度清晰度，照片拼接与对准误差维持2像素 之内。以最高质量还原芯片原始形貌</p>
                      </div>
                  </el-col>
                  <el-col :span='12'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>网表提取</span>
                          <p>依据芯片照片提取芯片简易版图，通过简 易版图来获得芯片网表信息，并转化为芯 片原理图</p>
                      </div>
                  </el-col>
                  <el-col :span='12'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>电路整理</span>
                          <p>还原原理图的设计结构与层次，辅助设计工 程师更好的理解电路的设计思想，节省设计 工程师的分析时间</p>
                      </div>
                  </el-col>
              </el-row>
          </div> -->
        </el-col>
      </el-row>
    </div>
    <el-row class="contentPc">
       <el-col :span='24' style="border-left:1px solid rgb(220,220,220);border-right:1px solid rgb(220,220,220);border-top:1px solid rgb(220,220,220);">
          <ContentNav :List="list" title="竞争力分析" titleEn="LCompetitive Analysis" @increase='init'></ContentNav>
       </el-col>
       <div v-html='contentHtmlMobile' class='mobileEditor' v-loading='loading'></div>
       <!-- <el-col :span='24'>
          <h3 style='color:#235E9D;'>竞争力分析业务</h3>
          <el-divider></el-divider>
          <p>聚跃检测竞争力分析业务，是以IC设计辅助软件为核心优势的集成电路技术分析、知识产权侵权分析和芯片设计的服务公司</p>
          <p>公司利用自主研发的芯片EDA工具ChipVision，结合先进的图像自动识别算法，提高了芯片解析的自动化程度。</p>
          <el-row :gutter="10">
                  <el-col :span='12'>
                      <img :src="require('../assets/组8.png')" alt="" height="200px" width="100%">
                  </el-col>
                  <el-col :span='12'>
                      <img :src="require('../assets/组7.png')" alt="" height="200px" width="100%">
                  </el-col>
          </el-row>
          <p>竞争力分析业务，致力于为客户提供优质的芯片解析服务，帮助IC设计企业掌握世界最先进的技术，促进国内集成电路行业的发展。</p>
          <p>公司利用自主研发的芯片EDA工具ChipVision，结合先进的图像自动识别算法，提高了芯片解析的自动化程度。</p>
          <el-row :gutter="100">
             <el-col :span='24'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>芯片去层</span>
                          <p>提供芯片化学处理，物理刻蚀，保证芯 片最好的平整度及洁净</p>
                      </div>
            </el-col>
              <el-col :span='24'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>芯片拍照</span>
                          <p>提供光学及电子扫描显微图像，保证照片高 度清晰度，照片拼接与对准误差维持2像素 之内。以最高质量还原芯片原始形貌</p>
                      </div>
                  </el-col>
                  <el-col :span='24'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>网表提取</span>
                          <p>依据芯片照片提取芯片简易版图，通过简 易版图来获得芯片网表信息，并转化为芯 片原理图</p>
                      </div>
                  </el-col>
                  <el-col :span='24'>
                      <div class="titleBtn">
                          <img :src="require('../assets/图层10.png')" alt="">
                          <span>电路整理</span>
                          <p>还原原理图的设计结构与层次，辅助设计工 程师更好的理解电路的设计思想，节省设计 工程师的分析时间</p>
                      </div>
                  </el-col>
          </el-row>
       </el-col> -->
    </el-row>
  </div>
</template>
<script>
import HeadNav from "../components/head.vue";
import ContentNav from "../components/content.vue";
import {getTheme,getNavTitle,getProduct} from '../api/allApiRequest.js'
export default {
  name: "business",
  data() {
    return {
      list: [],
      headNavImg:{},
      value:0,
      headTitle:'',
      contentHtmlMobile:'',
      contentHtmlPC:'',
      loading:false,
      activeId:'',
      defaultShowId:""
    };
  },
  components: {
    HeadNav,
    ContentNav
  },
  mounted(){
    this.value = location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[0].split('=')[1] : 0
    this.activeId =  location.hash.split('?')[1] ? location.hash.split('?')[1].split('&')[1].split('=')[1] : 0
    this.getThemeHead()
    getNavTitle().then(res=>{
      res.data.forEach(item=>{
        item.title == '竞争力分析' ? this.list = item.children : ''
      })
       //默认拿到第一条数据显示处理
      if(this.list.length){
        this.defaultShowId = this.list[0].children[0].id;
        this.headTitle = this.list[0].children[0].title;
        getProduct({defaultTypeId:this.defaultShowId}).then(res=>{
          let data = res.data.records[0]
          if(data){
                this.contentHtmlPC = data.profiles
                this.contentHtmlMobile = data.detailsPhone
          }
          this.loading = false
        })
      }else{
        this.headTitle="暂无数据";
        this.contentHtmlPC = "暂无数据";
        this.contentHtmlMobile = "暂无数据";
      }
    })
  },
  methods:{
  //主题返现
  getThemeHead(){
    getTheme({
      themeType : this.value
    }).then(res=>{
      this.headNavImg = res.data.records[0]
      res.data.records[0].picture = process.env.VUE_APP_WEB_URL + res.data.records[0].picture
    })
  },
  init(e){
     this.headTitle = e.title
      this.loading = true
      this.contentHtmlMobile = '暂无信息'
      this.contentHtmlPC = '暂无信息'
      getProduct({defaultTypeId:e.id}).then(res=>{
         let data = res.data.records[0]
        if(data){
             this.contentHtmlPC = data.profiles
             this.contentHtmlMobile = data.detailsPhone
        }
        this.loading = false
      })
  }
  }
};
</script>
<style scoped>
.contentPc{
  display: none;
}
 .content{
     margin: 50px auto;
     width: 1190px;
 }
 .titleBtn{
     height: 200px;
 }
.titleBtn span{
     display: inline-block;
     vertical-align: top;
     line-height: 50px;
     font-size: 30px;
     color: #235E9D;
     padding-left: 30px;
}
 .titleBtn img{
     height: 50px;
 }
 p{
    display: -webkit-box;
    overflow: hidden;
    white-space: normal !important;
    text-overflow: ellipsis;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    font-size: 16px;
    line-height: 16px;

 }
 @media screen and (max-width: 750px){
   .content{
     display: none;
   }
   .contentPc{
    display: block;
    margin: 20px 10px;
   }
   .titleBtn{
     height: 120px;
   }
   .titleBtn span{
     line-height: 30px;
     font-size: 20px;
     padding-left: 30px;
}
 .titleBtn img{
     height: 30px;
 }
 }
</style>